<div
  class="list-item menu-item"
  (mouseenter)="item.selected = true"
  (mouseleave)="item.selected = false"
  (click)="item.selected = false"
>
  <div class="row menu-item">
    <div class="col-10">
      <button
        data-toggle="collapse"
        type="button"
        (click)="select(item)"
        class="btn-panel panel-heading-drop {{
          item.selected ? '' : 'collapsed'
        }}"
      >
        {{ item.description }}
      </button>
    </div>
    <div class="col-2 list-item-icon">
      <div *ngIf="item.children.length; else quantityBlock">
        <a class="panel-heading collapsed"></a>
      </div>
      <ng-template #quantityBlock>
        <span class="badge badge-secondary">{{ item.quantity }}</span>
      </ng-template>
    </div>
  </div>
  <div
    *ngIf="item.children.length > 0"
    id="box{{ item.id }}"
    class="pl-3 list-group list-group-flush panel-collapse collapse {{
      item.selected ? 'show' : ''
    }}"
  >
    <div class="dropdown-box">
      <app-catalog-dropdown
        #submenu
        [selected]="i.selected"
        (onSelect)="onChildrenSelected($event)"
        *ngFor="let i of item.children"
        [item]="i"
        [parent]="parent + ' > ' + item.description"
        (breadCrumb)="saveBc($event)"
      ></app-catalog-dropdown>
    </div>
  </div>
</div>
